interface ClerkApiError {
  errors?: Array<{ message?: string; longMessage?: string }>
}

/** Clerk SDK calls reject with an object shaped like { errors: [{ message, longMessage }] }
 *  rather than a plain Error — this pulls out something displayable, falling back for
 *  anything else (network failure, unexpected shape). */
export function clerkErrorMessage(err: unknown, fallback: string): string {
  const clerkErr = err as ClerkApiError
  const first = clerkErr?.errors?.[0]
  return first?.longMessage ?? first?.message ?? fallback
}
